import e, { useState as t, useEffect as n } from "react";

function r(e, t) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, t) {
    var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null == n) return;
    var r,
        o,
        a = [],
        i = !0,
        c = !1;

    try {
      for (n = n.call(e); !(i = (r = n.next()).done) && (a.push(r.value), !t || a.length !== t); i = !0) {
        ;
      }
    } catch (e) {
      c = !0, o = e;
    } finally {
      try {
        i || null == n.return || n.return();
      } finally {
        if (c) throw o;
      }
    }

    return a;
  }(e, t) || function (e, t) {
    if (!e) return;
    if ("string" == typeof e) return o(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    "Object" === n && e.constructor && (n = e.constructor.name);
    if ("Map" === n || "Set" === n) return Array.from(e);
    if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return o(e, t);
  }(e, t) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function o(e, t) {
  (null == t || t > e.length) && (t = e.length);

  for (var n = 0, r = new Array(t); n < t; n++) {
    r[n] = e[n];
  }

  return r;
}

!function (e, t) {
  void 0 === t && (t = {});
  var n = t.insertAt;

  if (e && "undefined" != typeof document) {
    var r = document.head || document.getElementsByTagName("head")[0],
        o = document.createElement("style");
    o.type = "text/css", "top" === n && r.firstChild ? r.insertBefore(o, r.firstChild) : r.appendChild(o), o.styleSheet ? o.styleSheet.cssText = e : o.appendChild(document.createTextNode(e));
  }
}(".reactive-btn-wrapper,\n.reactive-btn {\n  --reactive-button-min-width: 100px;\n  --reactive-button-min-height: 35px;\n  --reactive-button-font-size: 14px;\n  --reactive-button-font-weight: 400;\n  --reactive-button-border-radius: 0px;\n  --reactive-button-text-color: #ffffff;\n  --reactive-progress-color: rgba(0, 0, 0, 0.15);\n\n  --reactive-button-primary-color: rgba(88, 103, 221, 1);\n  --reactive-button-secondary-color: rgba(108, 117, 125, 1);\n  --reactive-button-dark-color: rgba(66, 78, 106, 1);\n  --reactive-button-light-color: rgba(183, 186, 191, 1);\n  --reactive-button-green-color: rgba(37, 162, 51, 1);\n  --reactive-button-red-color: rgba(244, 81, 108, 1);\n  --reactive-button-yellow-color: rgba(255, 193, 7, 1);\n  --reactive-button-teal-color: rgba(0, 181, 173, 1);\n  --reactive-button-violet-color: rgba(100, 53, 201, 1);\n  --reactive-button-blue-color: rgba(66, 153, 225, 1);\n\n  --reactive-progress-outline-primary-color: rgba(88, 103, 221, 0.3);\n  --reactive-progress-outline-secondary-color: rgba(108, 117, 125, 0.3);\n  --reactive-progress-outline-dark-color: rgba(66, 78, 106, 0.3);\n  --reactive-progress-outline-light-color: rgba(214, 212, 212, 0.3);\n  --reactive-progress-outline-green-color: rgba(37, 162, 51, 0.3);\n  --reactive-progress-outline-red-color: rgba(244, 81, 108, 0.3);\n  --reactive-progress-outline-yellow-color: rgba(255, 193, 7, 0.3);\n  --reactive-progress-outline-teal-color: rgba(0, 181, 173, 0.3);\n  --reactive-progress-outline-violet-color: rgba(100, 53, 201, 0.3);\n  --reactive-progress-outline-blue-color: rgba(66, 153, 225, 0.3);\n}\n\n.reactive-btn-wrapper {\n  display: inline-block;\n  min-width: var(--reactive-button-min-width);\n  height: var(--reactive-button-min-height);\n}\n\n.reactive-btn-wrapper.tiny {\n  min-width: calc(var(--reactive-button-min-width) - 35px);\n  height: calc(var(--reactive-button-min-height) - 11px);\n}\n\n.reactive-btn-wrapper.small {\n  min-width: calc(var(--reactive-button-min-width) - 25px);\n  height: calc(var(--reactive-button-min-height) - 5px);\n}\n\n.reactive-btn-wrapper.large {\n  min-width: calc(var(--reactive-button-min-width) + 25px);\n  height: calc(var(--reactive-button-min-height) + 5px);\n}\n\n.reactive-btn-wrapper.block {\n  width: 100%;\n}\n\n.reactive-btn {\n  margin-bottom: 0;\n  padding: 6px 14px 6px;\n  font-size: var(--reactive-button-font-size);\n  font-weight: var(--reactive-button-font-weight);\n  width: 100%;\n  min-height: 100%;\n  color: var(--reactive-button-text-color);\n  text-align: center;\n  line-height: 1.5;\n  text-decoration: none;\n  user-select: none;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  vertical-align: middle;\n  cursor: pointer;\n  background-color: var(--reactive-button-primary-color);\n  border: none;\n  -webkit-border-radius: var(--reactive-button-border-radius);\n  -moz-border-radius: var(--reactive-button-border-radius);\n  border-radius: var(--reactive-button-border-radius);\n  -webkit-box-shadow: inset 0 -2px 0 rgba(0, 0, 0, 0.2);\n  -moz-box-shadow: inset 0 -2px 0 rgba(0, 0, 0, 0.2);\n  box-shadow: inset 0 -2px 0 rgba(0, 0, 0, 0.2);\n  -webkit-transition: 0.1s;\n  -moz-transition: 0.1s;\n  transition: 0.1s;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  position: relative;\n  overflow: hidden;\n  outline: none !important;\n  align-items: center;\n  -webkit-box-pack: center;\n  -webkit-box-align: center;\n}\n\n.reactive-btn.outline {\n  background-color: transparent !important;\n}\n\n.reactive-btn:disabled {\n  cursor: default;\n}\n\n.reactive-btn:hover:not(:disabled):not(.disabled) {\n  opacity: 0.85;\n}\n\n.reactive-btn:not(.no-animation):hover:not(:disabled):not(.disabled) {\n  opacity: 0.85;\n  -webkit-box-shadow: inset 0 -4px 0 rgba(0, 0, 0, 0.2);\n  -moz-box-shadow: inset 0 -4px 0 rgba(0, 0, 0, 0.2);\n  box-shadow: inset 0 -4px 0 rgba(0, 0, 0, 0.2);\n  margin-top: -1px;\n  padding: 6px 14px 8px;\n}\n\n.reactive-btn:not(.no-animation):active:not(:disabled):not(.disabled) {\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  box-shadow: none;\n  margin-top: 1px;\n  padding: 6px 14px 4px;\n}\n\n.reactive-btn:focus {\n  outline: none !important;\n}\n\n.reactive-btn.rounded {\n  border-radius: 50rem !important;\n  -webkit-border-radius: 50rem !important;\n  -moz-border-radius: 50rem !important;\n}\n\n.reactive-btn.disabled {\n  opacity: 0.7;\n}\n\n.reactive-btn .content {\n  position: relative;\n}\n\n.reactive-btn .progress {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 100%;\n  width: 100%;\n  background-color: var(--reactive-progress-color);\n  transform: translateX(-100%);\n  transition: transform 0.2s ease;\n}\n\n.reactive-btn:not([data-button-state='idle']) .progress {\n  transform: translateX(0%);\n  transition: transform 3s cubic-bezier(0.59, 0.01, 0.41, 0.99);\n}\n\n.reactive-btn .drbll1:after {\n  content: '.';\n  animation: dots 1s steps(5, end) infinite;\n}\n\n.reactive-btn-wrapper.tiny .reactive-btn {\n  font-size: calc(var(--reactive-button-font-size) - 4px);\n  line-height: 1;\n}\n\n.reactive-btn-wrapper.small .reactive-btn {\n  font-size: calc(var(--reactive-button-font-size) - 2px);\n}\n\n.reactive-btn-wrapper.large .reactive-btn {\n  font-size: calc(var(--reactive-button-font-size) + 2px);\n}\n\n/* primary button starts */\n.reactive-btn.primary.outline {\n  border-color: var(--reactive-button-primary-color);\n  color: var(--reactive-button-primary-color);\n  border: 1px solid var(--reactive-button-primary-color);\n  box-shadow: inset 0 -1px 0 var(--reactive-button-primary-color);\n  -webkit-box-shadow: inset 0 -1px 0 var(--reactive-button-primary-color);\n  -moz-box-shadow: inset 0 -1px 0 var(--reactive-button-primary-color);\n}\n\n.reactive-btn.primary.outline .progress {\n  background-color: var(--reactive-progress-outline-primary-color) !important;\n}\n\n.reactive-btn.primary.outline:hover:not(:disabled):not(.disabled) {\n  box-shadow: inset 0 -3px 0 var(--reactive-button-primary-color);\n  -webkit-box-shadow: inset 0 -3px 0 var(--reactive-button-primary-color);\n  -moz-box-shadow: inset 0 -3px 0 var(--reactive-button-primary-color);\n}\n\n.reactive-btn.primary.shadow {\n  box-shadow: 0px 5px 16px -3px var(--reactive-button-primary-color) !important;\n}\n\n/* primary button ends */\n\n/* secondary button starts */\n.reactive-btn.secondary {\n  background: var(--reactive-button-secondary-color);\n}\n\n.reactive-btn.secondary.outline {\n  border-color: var(--reactive-button-secondary-color);\n  color: var(--reactive-button-secondary-color);\n  border: 1px solid var(--reactive-button-secondary-color);\n  box-shadow: inset 0 -1px 0 var(--reactive-button-secondary-color);\n  -webkit-box-shadow: inset 0 -1px 0 var(--reactive-button-secondary-color);\n  -moz-box-shadow: inset 0 -1px 0 var(--reactive-button-secondary-color);\n}\n\n.reactive-btn.secondary.outline .progress {\n  background-color: var(--reactive-progress-outline-secondary-color) !important;\n}\n\n.reactive-btn.secondary.outline:hover:not(:disabled):not(.disabled) {\n  box-shadow: inset 0 -3px 0 var(--reactive-button-secondary-color);\n  -webkit-box-shadow: inset 0 -3px 0 var(--reactive-button-secondary-color);\n  -moz-box-shadow: inset 0 -3px 0 var(--reactive-button-secondary-color);\n}\n\n.reactive-btn.secondary.shadow {\n  box-shadow: 0px 5px 16px -3px var(--reactive-button-secondary-color) !important;\n}\n\n/* secondary button ends */\n\n/* dark button starts */\n\n.reactive-btn.dark {\n  background: var(--reactive-button-dark-color);\n}\n\n.reactive-btn.dark.outline {\n  border-color: var(--reactive-button-dark-color);\n  color: var(--reactive-button-dark-color);\n  border: 1px solid var(--reactive-button-dark-color);\n  box-shadow: inset 0 -1px 0 var(--reactive-button-dark-color);\n  -webkit-box-shadow: inset 0 -1px 0 var(--reactive-button-dark-color);\n  -moz-box-shadow: inset 0 -1px 0 var(--reactive-button-dark-color);\n}\n\n.reactive-btn.dark.outline .progress {\n  background-color: var(--reactive-progress-outline-dark-color) !important;\n}\n\n.reactive-btn.dark.outline:hover:not(:disabled):not(.disabled) {\n  box-shadow: inset 0 -3px 0 var(--reactive-button-dark-color);\n  -webkit-box-shadow: inset 0 -3px 0 var(--reactive-button-dark-color);\n  -moz-box-shadow: inset 0 -3px 0 var(--reactive-button-dark-color);\n}\n\n.reactive-btn.dark.shadow {\n  box-shadow: 0px 5px 16px -3px var(--reactive-button-dark-color) !important;\n}\n\n/* dark button ends */\n\n/* light button starts */\n\n.reactive-btn.light {\n  background: var(--reactive-button-light-color);\n  color: #000000;\n}\n\n.reactive-btn.light.outline {\n  border-color: var(--reactive-button-light-color);\n  color: var(--reactive-button-light-color);\n  border: 1px solid var(--reactive-button-light-color);\n  box-shadow: inset 0 -1px 0 var(--reactive-button-light-color);\n  -webkit-box-shadow: inset 0 -1px 0 var(--reactive-button-light-color);\n  -moz-box-shadow: inset 0 -1px 0 var(--reactive-button-light-color);\n}\n\n.reactive-btn.light.outline .progress {\n  background-color: var(--reactive-progress-outline-light-color) !important;\n}\n\n.reactive-btn.light.outline:hover:not(:disabled):not(.disabled) {\n  box-shadow: inset 0 -3px 0 var(--reactive-button-light-color);\n  -webkit-box-shadow: inset 0 -3px 0 var(--reactive-button-light-color);\n  -moz-box-shadow: inset 0 -3px 0 var(--reactive-button-light-color);\n}\n\n.reactive-btn.light.shadow {\n  box-shadow: 0px 5px 16px -3px var(--reactive-button-light-color) !important;\n}\n\n/* light button ends */\n\n/* green button starts */\n.reactive-btn.green {\n  background: var(--reactive-button-green-color);\n}\n\n.reactive-btn.green.outline {\n  border-color: var(--reactive-button-green-color);\n  color: var(--reactive-button-green-color);\n  border: 1px solid var(--reactive-button-green-color);\n  box-shadow: inset 0 -1px 0 var(--reactive-button-green-color);\n  -webkit-box-shadow: inset 0 -1px 0 var(--reactive-button-green-color);\n  -moz-box-shadow: inset 0 -1px 0 var(--reactive-button-green-color);\n}\n\n.reactive-btn.green.outline .progress {\n  background-color: var(--reactive-progress-outline-green-color) !important;\n}\n\n.reactive-btn.green.outline:hover:not(:disabled):not(.disabled) {\n  box-shadow: inset 0 -3px 0 var(--reactive-button-green-color);\n  -webkit-box-shadow: inset 0 -3px 0 var(--reactive-button-green-color);\n  -moz-box-shadow: inset 0 -3px 0 var(--reactive-button-green-color);\n}\n\n.reactive-btn.green.shadow {\n  box-shadow: 0px 5px 16px -3px var(--reactive-button-green-color) !important;\n}\n\n/* green button ends */\n\n/* red button starts */\n.reactive-btn.red {\n  background: var(--reactive-button-red-color);\n}\n\n.reactive-btn.red.outline {\n  border-color: var(--reactive-button-red-color);\n  color: var(--reactive-button-red-color);\n  border: 1px solid var(--reactive-button-red-color);\n  box-shadow: inset 0 -1px 0 var(--reactive-button-red-color);\n  -webkit-box-shadow: inset 0 -1px 0 var(--reactive-button-red-color);\n  -moz-box-shadow: inset 0 -1px 0 var(--reactive-button-red-color);\n}\n\n.reactive-btn.red.outline .progress {\n  background-color: var(--reactive-progress-outline-red-color) !important;\n}\n\n.reactive-btn.red.outline:hover:not(:disabled):not(.disabled) {\n  box-shadow: inset 0 -3px 0 var(--reactive-button-red-color);\n  -webkit-box-shadow: inset 0 -3px 0 var(--reactive-button-red-color);\n  -moz-box-shadow: inset 0 -3px 0 var(--reactive-button-red-color);\n}\n\n.reactive-btn.red.shadow {\n  box-shadow: 0px 5px 16px -3px var(--reactive-button-red-color) !important;\n}\n\n/* red button ends */\n\n/* yellow button starts */\n.reactive-btn.yellow {\n  background: var(--reactive-button-yellow-color);\n  color: #000000;\n}\n\n.reactive-btn.yellow.outline {\n  border-color: var(--reactive-button-yellow-color);\n  color: var(--reactive-button-yellow-color);\n  border: 1px solid var(--reactive-button-yellow-color);\n  box-shadow: inset 0 -1px 0 var(--reactive-button-yellow-color);\n  -webkit-box-shadow: inset 0 -1px 0 var(--reactive-button-yellow-color);\n  -moz-box-shadow: inset 0 -1px 0 var(--reactive-button-yellow-color);\n}\n\n.reactive-btn.yellow.outline .progress {\n  background-color: var(--reactive-progress-outline-yellow-color) !important;\n}\n\n.reactive-btn.yellow.outline:hover:not(:disabled):not(.disabled) {\n  box-shadow: inset 0 -3px 0 var(--reactive-button-yellow-color);\n  -webkit-box-shadow: inset 0 -3px 0 var(--reactive-button-yellow-color);\n  -moz-box-shadow: inset 0 -3px 0 var(--reactive-button-yellow-color);\n}\n\n.reactive-btn.yellow.shadow {\n  box-shadow: 0px 5px 16px -3px var(--reactive-button-yellow-color) !important;\n}\n\n/* yellow button ends */\n\n/* teal button starts */\n.reactive-btn.teal {\n  background: var(--reactive-button-teal-color);\n}\n\n.reactive-btn.teal.outline {\n  border-color: var(--reactive-button-teal-color);\n  color: var(--reactive-button-teal-color);\n  border: 1px solid var(--reactive-button-teal-color);\n  box-shadow: inset 0 -1px 0 var(--reactive-button-teal-color);\n  -webkit-box-shadow: inset 0 -1px 0 var(--reactive-button-teal-color);\n  -moz-box-shadow: inset 0 -1px 0 var(--reactive-button-teal-color);\n}\n\n.reactive-btn.teal.outline .progress {\n  background-color: var(--reactive-progress-outline-teal-color) !important;\n}\n\n.reactive-btn.teal.outline:hover:not(:disabled):not(.disabled) {\n  box-shadow: inset 0 -3px 0 var(--reactive-button-teal-color);\n  -webkit-box-shadow: inset 0 -3px 0 var(--reactive-button-teal-color);\n  -moz-box-shadow: inset 0 -3px 0 var(--reactive-button-teal-color);\n}\n\n.reactive-btn.teal.shadow {\n  box-shadow: 0px 5px 16px -3px var(--reactive-button-teal-color) !important;\n}\n\n/* teal button ends */\n\n/* violet button starts */\n.reactive-btn.violet {\n  background: var(--reactive-button-violet-color);\n}\n\n.reactive-btn.violet.outline {\n  border-color: var(--reactive-button-violet-color);\n  color: var(--reactive-button-violet-color);\n  border: 1px solid var(--reactive-button-violet-color);\n  box-shadow: inset 0 -1px 0 var(--reactive-button-violet-color);\n  -webkit-box-shadow: inset 0 -1px 0 var(--reactive-button-violet-color);\n  -moz-box-shadow: inset 0 -1px 0 var(--reactive-button-violet-color);\n}\n\n.reactive-btn.violet.outline .progress {\n  background-color: var(--reactive-progress-outline-violet-color) !important;\n}\n\n.reactive-btn.violet.outline:hover:not(:disabled):not(.disabled) {\n  box-shadow: inset 0 -3px 0 var(--reactive-button-violet-color);\n  -webkit-box-shadow: inset 0 -3px 0 var(--reactive-button-violet-color);\n  -moz-box-shadow: inset 0 -3px 0 var(--reactive-button-violet-color);\n}\n\n.reactive-btn.violet.shadow {\n  box-shadow: 0px 5px 16px -3px var(--reactive-button-violet-color) !important;\n}\n\n/* violet button ends */\n\n/* blue button starts */\n.reactive-btn.blue {\n  background: var(--reactive-button-blue-color);\n}\n\n.reactive-btn.blue.outline {\n  border-color: var(--reactive-button-blue-color);\n  color: var(--reactive-button-blue-color);\n  border: 1px solid var(--reactive-button-blue-color);\n  box-shadow: inset 0 -1px 0 var(--reactive-button-blue-color);\n  -webkit-box-shadow: inset 0 -1px 0 var(--reactive-button-blue-color);\n  -moz-box-shadow: inset 0 -1px 0 var(--reactive-button-blue-color);\n}\n\n.reactive-btn.blue.outline .progress {\n  background-color: var(--reactive-progress-outline-blue-color) !important;\n}\n\n.reactive-btn.blue.outline:hover:not(:disabled):not(.disabled) {\n  box-shadow: inset 0 -3px 0 var(--reactive-button-blue-color);\n  -webkit-box-shadow: inset 0 -3px 0 var(--reactive-button-blue-color);\n  -moz-box-shadow: inset 0 -3px 0 var(--reactive-button-blue-color);\n}\n\n.reactive-btn.blue.shadow {\n  box-shadow: 0px 5px 16px -3px var(--reactive-button-blue-color) !important;\n}\n\n/* blue button ends */\n\n.reactive-spin {\n  animation: reactive-spin 2s infinite linear;\n}\n.reactive-btn-loading-svg,\n.reactive-btn-success-svg,\n.reactive-btn-error-svg {\n  display: inline-block;\n  font-size: inherit;\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n\n@keyframes dots {\n  0%,\n  20% {\n    color: rgba(0, 0, 0, 0);\n    text-shadow: 0.25em 0 0 rgba(0, 0, 0, 0), 0.5em 0 0 rgba(0, 0, 0, 0);\n  }\n\n  40% {\n    color: white;\n    text-shadow: 0.25em 0 0 rgba(0, 0, 0, 0), 0.5em 0 0 rgba(0, 0, 0, 0);\n  }\n\n  60% {\n    text-shadow: 0.25em 0 0 white, 0.5em 0 0 rgba(0, 0, 0, 0);\n  }\n\n  80%,\n  100% {\n    text-shadow: 0.25em 0 0 white, 0.5em 0 0 white;\n  }\n}\n\n@keyframes reactive-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n");
var a,
    i = {
  exports: {}
},
    c = {
  exports: {}
},
    s = {};
var l,
    u,
    b,
    p,
    d,
    v,
    f,
    y,
    m,
    x,
    g,
    h,
    w,
    k,
    S = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function E() {
  return u || (u = 1, e = c, "production" === process.env.NODE_ENV ? e.exports = function () {
    if (a) return s;
    a = 1;
    var e = "function" == typeof Symbol && Symbol.for,
        t = e ? Symbol.for("react.element") : 60103,
        n = e ? Symbol.for("react.portal") : 60106,
        r = e ? Symbol.for("react.fragment") : 60107,
        o = e ? Symbol.for("react.strict_mode") : 60108,
        i = e ? Symbol.for("react.profiler") : 60114,
        c = e ? Symbol.for("react.provider") : 60109,
        l = e ? Symbol.for("react.context") : 60110,
        u = e ? Symbol.for("react.async_mode") : 60111,
        b = e ? Symbol.for("react.concurrent_mode") : 60111,
        p = e ? Symbol.for("react.forward_ref") : 60112,
        d = e ? Symbol.for("react.suspense") : 60113,
        v = e ? Symbol.for("react.suspense_list") : 60120,
        f = e ? Symbol.for("react.memo") : 60115,
        y = e ? Symbol.for("react.lazy") : 60116,
        m = e ? Symbol.for("react.block") : 60121,
        x = e ? Symbol.for("react.fundamental") : 60117,
        g = e ? Symbol.for("react.responder") : 60118,
        h = e ? Symbol.for("react.scope") : 60119;

    function w(e) {
      if ("object" == typeof e && null !== e) {
        var a = e.$$typeof;

        switch (a) {
          case t:
            switch (e = e.type) {
              case u:
              case b:
              case r:
              case i:
              case o:
              case d:
                return e;

              default:
                switch (e = e && e.$$typeof) {
                  case l:
                  case p:
                  case y:
                  case f:
                  case c:
                    return e;

                  default:
                    return a;
                }

            }

          case n:
            return a;
        }
      }
    }

    function k(e) {
      return w(e) === b;
    }

    return s.AsyncMode = u, s.ConcurrentMode = b, s.ContextConsumer = l, s.ContextProvider = c, s.Element = t, s.ForwardRef = p, s.Fragment = r, s.Lazy = y, s.Memo = f, s.Portal = n, s.Profiler = i, s.StrictMode = o, s.Suspense = d, s.isAsyncMode = function (e) {
      return k(e) || w(e) === u;
    }, s.isConcurrentMode = k, s.isContextConsumer = function (e) {
      return w(e) === l;
    }, s.isContextProvider = function (e) {
      return w(e) === c;
    }, s.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === t;
    }, s.isForwardRef = function (e) {
      return w(e) === p;
    }, s.isFragment = function (e) {
      return w(e) === r;
    }, s.isLazy = function (e) {
      return w(e) === y;
    }, s.isMemo = function (e) {
      return w(e) === f;
    }, s.isPortal = function (e) {
      return w(e) === n;
    }, s.isProfiler = function (e) {
      return w(e) === i;
    }, s.isStrictMode = function (e) {
      return w(e) === o;
    }, s.isSuspense = function (e) {
      return w(e) === d;
    }, s.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === r || e === b || e === i || e === o || e === d || e === v || "object" == typeof e && null !== e && (e.$$typeof === y || e.$$typeof === f || e.$$typeof === c || e.$$typeof === l || e.$$typeof === p || e.$$typeof === x || e.$$typeof === g || e.$$typeof === h || e.$$typeof === m);
    }, s.typeOf = w, s;
  }() : e.exports = (l || (l = 1, "production" !== process.env.NODE_ENV && function () {
    var e = "function" == typeof Symbol && Symbol.for,
        t = e ? Symbol.for("react.element") : 60103,
        n = e ? Symbol.for("react.portal") : 60106,
        r = e ? Symbol.for("react.fragment") : 60107,
        o = e ? Symbol.for("react.strict_mode") : 60108,
        a = e ? Symbol.for("react.profiler") : 60114,
        i = e ? Symbol.for("react.provider") : 60109,
        c = e ? Symbol.for("react.context") : 60110,
        s = e ? Symbol.for("react.async_mode") : 60111,
        l = e ? Symbol.for("react.concurrent_mode") : 60111,
        u = e ? Symbol.for("react.forward_ref") : 60112,
        b = e ? Symbol.for("react.suspense") : 60113,
        p = e ? Symbol.for("react.suspense_list") : 60120,
        d = e ? Symbol.for("react.memo") : 60115,
        v = e ? Symbol.for("react.lazy") : 60116,
        f = e ? Symbol.for("react.block") : 60121,
        y = e ? Symbol.for("react.fundamental") : 60117,
        m = e ? Symbol.for("react.responder") : 60118,
        x = e ? Symbol.for("react.scope") : 60119;

    function g(e) {
      if ("object" == typeof e && null !== e) {
        var p = e.$$typeof;

        switch (p) {
          case t:
            var f = e.type;

            switch (f) {
              case s:
              case l:
              case r:
              case a:
              case o:
              case b:
                return f;

              default:
                var y = f && f.$$typeof;

                switch (y) {
                  case c:
                  case u:
                  case v:
                  case d:
                  case i:
                    return y;

                  default:
                    return p;
                }

            }

          case n:
            return p;
        }
      }
    }

    var h = s,
        w = l,
        k = c,
        E = i,
        O = t,
        T = u,
        z = r,
        $ = v,
        j = d,
        N = n,
        C = a,
        P = o,
        _ = b,
        I = !1;

    function R(e) {
      return g(e) === l;
    }

    S.AsyncMode = h, S.ConcurrentMode = w, S.ContextConsumer = k, S.ContextProvider = E, S.Element = O, S.ForwardRef = T, S.Fragment = z, S.Lazy = $, S.Memo = j, S.Portal = N, S.Profiler = C, S.StrictMode = P, S.Suspense = _, S.isAsyncMode = function (e) {
      return I || (I = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), R(e) || g(e) === s;
    }, S.isConcurrentMode = R, S.isContextConsumer = function (e) {
      return g(e) === c;
    }, S.isContextProvider = function (e) {
      return g(e) === i;
    }, S.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === t;
    }, S.isForwardRef = function (e) {
      return g(e) === u;
    }, S.isFragment = function (e) {
      return g(e) === r;
    }, S.isLazy = function (e) {
      return g(e) === v;
    }, S.isMemo = function (e) {
      return g(e) === d;
    }, S.isPortal = function (e) {
      return g(e) === n;
    }, S.isProfiler = function (e) {
      return g(e) === a;
    }, S.isStrictMode = function (e) {
      return g(e) === o;
    }, S.isSuspense = function (e) {
      return g(e) === b;
    }, S.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === r || e === l || e === a || e === o || e === b || e === p || "object" == typeof e && null !== e && (e.$$typeof === v || e.$$typeof === d || e.$$typeof === i || e.$$typeof === c || e.$$typeof === u || e.$$typeof === y || e.$$typeof === m || e.$$typeof === x || e.$$typeof === f);
    }, S.typeOf = g;
  }()), S)), c.exports;
  var e;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


function O() {
  if (v) return d;
  v = 1;
  return d = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}

function T() {
  return y ? f : (y = 1, f = Function.call.bind(Object.prototype.hasOwnProperty));
}

if ("production" !== process.env.NODE_ENV) {
  var z = E();

  i.exports = function () {
    if (h) return g;
    h = 1;

    var e = E(),
        t = function () {
      if (p) return b;
      p = 1;
      var e = Object.getOwnPropertySymbols,
          t = Object.prototype.hasOwnProperty,
          n = Object.prototype.propertyIsEnumerable;

      function r(e) {
        if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
        return Object(e);
      }

      return b = function () {
        try {
          if (!Object.assign) return !1;
          var e = new String("abc");
          if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

          for (var t = {}, n = 0; n < 10; n++) {
            t["_" + String.fromCharCode(n)] = n;
          }

          if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
            return t[e];
          }).join("")) return !1;
          var r = {};
          return "abcdefghijklmnopqrst".split("").forEach(function (e) {
            r[e] = e;
          }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
        } catch (e) {
          return !1;
        }
      }() ? Object.assign : function (o, a) {
        for (var i, c, s = r(o), l = 1; l < arguments.length; l++) {
          for (var u in i = Object(arguments[l])) {
            t.call(i, u) && (s[u] = i[u]);
          }

          if (e) {
            c = e(i);

            for (var b = 0; b < c.length; b++) {
              n.call(i, c[b]) && (s[c[b]] = i[c[b]]);
            }
          }
        }

        return s;
      }, b;
    }(),
        n = O(),
        r = T(),
        o = function () {
      if (x) return m;
      x = 1;

      var e = function e() {};

      if ("production" !== process.env.NODE_ENV) {
        var t = O(),
            n = {},
            r = T();

        e = function e(_e) {
          var t = "Warning: " + _e;
          "undefined" != typeof console && console.error(t);

          try {
            throw new Error(t);
          } catch (e) {}
        };
      }

      function o(o, a, i, c, s) {
        if ("production" !== process.env.NODE_ENV) for (var l in o) {
          if (r(o, l)) {
            var u;

            try {
              if ("function" != typeof o[l]) {
                var b = Error((c || "React class") + ": " + i + " type `" + l + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[l] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw b.name = "Invariant Violation", b;
              }

              u = o[l](a, l, c, i, null, t);
            } catch (e) {
              u = e;
            }

            if (!u || u instanceof Error || e((c || "React class") + ": type specification of " + i + " `" + l + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof u + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), u instanceof Error && !(u.message in n)) {
              n[u.message] = !0;
              var p = s ? s() : "";
              e("Failed " + i + " type: " + u.message + (null != p ? p : ""));
            }
          }
        }
      }

      return o.resetWarningCache = function () {
        "production" !== process.env.NODE_ENV && (n = {});
      }, m = o;
    }(),
        a = function a() {};

    function i() {
      return null;
    }

    return "production" !== process.env.NODE_ENV && (a = function a(e) {
      var t = "Warning: " + e;
      "undefined" != typeof console && console.error(t);

      try {
        throw new Error(t);
      } catch (e) {}
    }), g = function g(c, s) {
      var l = "function" == typeof Symbol && Symbol.iterator,
          u = "<<anonymous>>",
          b = {
        array: f("array"),
        bigint: f("bigint"),
        bool: f("boolean"),
        func: f("function"),
        number: f("number"),
        object: f("object"),
        string: f("string"),
        symbol: f("symbol"),
        any: v(i),
        arrayOf: function arrayOf(e) {
          return v(function (t, r, o, a, i) {
            if ("function" != typeof e) return new d("Property `" + i + "` of component `" + o + "` has invalid PropType notation inside arrayOf.");
            var c = t[r];
            if (!Array.isArray(c)) return new d("Invalid " + a + " `" + i + "` of type `" + x(c) + "` supplied to `" + o + "`, expected an array.");

            for (var s = 0; s < c.length; s++) {
              var l = e(c, s, o, a, i + "[" + s + "]", n);
              if (l instanceof Error) return l;
            }

            return null;
          });
        },
        element: v(function (e, t, n, r, o) {
          var a = e[t];
          return c(a) ? null : new d("Invalid " + r + " `" + o + "` of type `" + x(a) + "` supplied to `" + n + "`, expected a single ReactElement.");
        }),
        elementType: v(function (t, n, r, o, a) {
          var i = t[n];
          return e.isValidElementType(i) ? null : new d("Invalid " + o + " `" + a + "` of type `" + x(i) + "` supplied to `" + r + "`, expected a single ReactElement type.");
        }),
        instanceOf: function instanceOf(e) {
          return v(function (t, n, r, o, a) {
            if (!(t[n] instanceof e)) {
              var i = e.name || u;
              return new d("Invalid " + o + " `" + a + "` of type `" + ((c = t[n]).constructor && c.constructor.name ? c.constructor.name : u) + "` supplied to `" + r + "`, expected instance of `" + i + "`.");
            }

            var c;
            return null;
          });
        },
        node: v(function (e, t, n, r, o) {
          return m(e[t]) ? null : new d("Invalid " + r + " `" + o + "` supplied to `" + n + "`, expected a ReactNode.");
        }),
        objectOf: function objectOf(e) {
          return v(function (t, o, a, i, c) {
            if ("function" != typeof e) return new d("Property `" + c + "` of component `" + a + "` has invalid PropType notation inside objectOf.");
            var s = t[o],
                l = x(s);
            if ("object" !== l) return new d("Invalid " + i + " `" + c + "` of type `" + l + "` supplied to `" + a + "`, expected an object.");

            for (var u in s) {
              if (r(s, u)) {
                var b = e(s, u, a, i, c + "." + u, n);
                if (b instanceof Error) return b;
              }
            }

            return null;
          });
        },
        oneOf: function oneOf(e) {
          if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && a(arguments.length > 1 ? "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])." : "Invalid argument supplied to oneOf, expected an array."), i;

          function t(t, n, r, o, a) {
            for (var i = t[n], c = 0; c < e.length; c++) {
              if (p(i, e[c])) return null;
            }

            var s = JSON.stringify(e, function (e, t) {
              return "symbol" === g(t) ? String(t) : t;
            });
            return new d("Invalid " + o + " `" + a + "` of value `" + String(i) + "` supplied to `" + r + "`, expected one of " + s + ".");
          }

          return v(t);
        },
        oneOfType: function oneOfType(e) {
          if (!Array.isArray(e)) return "production" !== process.env.NODE_ENV && a("Invalid argument supplied to oneOfType, expected an instance of array."), i;

          for (var t = 0; t < e.length; t++) {
            var o = e[t];
            if ("function" != typeof o) return a("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + h(o) + " at index " + t + "."), i;
          }

          return v(function (t, o, a, i, c) {
            for (var s = [], l = 0; l < e.length; l++) {
              var u = (0, e[l])(t, o, a, i, c, n);
              if (null == u) return null;
              u.data && r(u.data, "expectedType") && s.push(u.data.expectedType);
            }

            return new d("Invalid " + i + " `" + c + "` supplied to `" + a + "`" + (s.length > 0 ? ", expected one of type [" + s.join(", ") + "]" : "") + ".");
          });
        },
        shape: function shape(e) {
          return v(function (t, r, o, a, i) {
            var c = t[r],
                s = x(c);
            if ("object" !== s) return new d("Invalid " + a + " `" + i + "` of type `" + s + "` supplied to `" + o + "`, expected `object`.");

            for (var l in e) {
              var u = e[l];
              if ("function" != typeof u) return y(o, a, i, l, g(u));
              var b = u(c, l, o, a, i + "." + l, n);
              if (b) return b;
            }

            return null;
          });
        },
        exact: function exact(e) {
          return v(function (o, a, i, c, s) {
            var l = o[a],
                u = x(l);
            if ("object" !== u) return new d("Invalid " + c + " `" + s + "` of type `" + u + "` supplied to `" + i + "`, expected `object`.");
            var b = t({}, o[a], e);

            for (var p in b) {
              var v = e[p];
              if (r(e, p) && "function" != typeof v) return y(i, c, s, p, g(v));
              if (!v) return new d("Invalid " + c + " `" + s + "` key `" + p + "` supplied to `" + i + "`.\nBad object: " + JSON.stringify(o[a], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
              var f = v(l, p, i, c, s + "." + p, n);
              if (f) return f;
            }

            return null;
          });
        }
      };

      function p(e, t) {
        return e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
      }

      function d(e, t) {
        this.message = e, this.data = t && "object" == typeof t ? t : {}, this.stack = "";
      }

      function v(e) {
        if ("production" !== process.env.NODE_ENV) var t = {},
            r = 0;

        function o(o, i, c, l, b, p, v) {
          if (l = l || u, p = p || c, v !== n) {
            if (s) {
              var f = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
              throw f.name = "Invariant Violation", f;
            }

            if ("production" !== process.env.NODE_ENV && "undefined" != typeof console) {
              var y = l + ":" + c;
              !t[y] && r < 3 && (a("You are manually calling a React.PropTypes validation function for the `" + p + "` prop on `" + l + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), t[y] = !0, r++);
            }
          }

          return null == i[c] ? o ? null === i[c] ? new d("The " + b + " `" + p + "` is marked as required in `" + l + "`, but its value is `null`.") : new d("The " + b + " `" + p + "` is marked as required in `" + l + "`, but its value is `undefined`.") : null : e(i, c, l, b, p);
        }

        var i = o.bind(null, !1);
        return i.isRequired = o.bind(null, !0), i;
      }

      function f(e) {
        return v(function (t, n, r, o, a, i) {
          var c = t[n];
          return x(c) !== e ? new d("Invalid " + o + " `" + a + "` of type `" + g(c) + "` supplied to `" + r + "`, expected `" + e + "`.", {
            expectedType: e
          }) : null;
        });
      }

      function y(e, t, n, r, o) {
        return new d((e || "React class") + ": " + t + " type `" + n + "." + r + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + o + "`.");
      }

      function m(e) {
        switch (typeof e) {
          case "number":
          case "string":
          case "undefined":
            return !0;

          case "boolean":
            return !e;

          case "object":
            if (Array.isArray(e)) return e.every(m);
            if (null === e || c(e)) return !0;

            var t = function (e) {
              var t = e && (l && e[l] || e["@@iterator"]);
              if ("function" == typeof t) return t;
            }(e);

            if (!t) return !1;
            var n,
                r = t.call(e);

            if (t !== e.entries) {
              for (; !(n = r.next()).done;) {
                if (!m(n.value)) return !1;
              }
            } else for (; !(n = r.next()).done;) {
              var o = n.value;
              if (o && !m(o[1])) return !1;
            }

            return !0;

          default:
            return !1;
        }
      }

      function x(e) {
        var t = typeof e;
        return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : function (e, t) {
          return "symbol" === e || !!t && ("Symbol" === t["@@toStringTag"] || "function" == typeof Symbol && t instanceof Symbol);
        }(t, e) ? "symbol" : t;
      }

      function g(e) {
        if (null == e) return "" + e;
        var t = x(e);

        if ("object" === t) {
          if (e instanceof Date) return "date";
          if (e instanceof RegExp) return "regexp";
        }

        return t;
      }

      function h(e) {
        var t = g(e);

        switch (t) {
          case "array":
          case "object":
            return "an " + t;

          case "boolean":
          case "date":
          case "regexp":
            return "a " + t;

          default:
            return t;
        }
      }

      return d.prototype = Error.prototype, b.checkPropTypes = o, b.resetWarningCache = o.resetWarningCache, b.PropTypes = b, b;
    }, g;
  }()(z.isElement, !0);
} else i.exports = function () {
  if (k) return w;
  k = 1;
  var e = O();

  function t() {}

  function n() {}

  return n.resetWarningCache = t, w = function w() {
    function r(t, n, r, o, a, i) {
      if (i !== e) {
        var c = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw c.name = "Invariant Violation", c;
      }
    }

    function o() {
      return r;
    }

    r.isRequired = r;
    var a = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return a.PropTypes = a, a;
  };
}()();

var $ = e.createElement("svg", {
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "spinner",
  className: "reactive-btn-loading-svg reactive-spin",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, e.createElement("path", {
  fill: "currentColor",
  d: "M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"
})),
    j = e.createElement("svg", {
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "check",
  className: "reactive-btn-success-svg",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, e.createElement("path", {
  fill: "currentColor",
  d: "M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"
})),
    N = e.createElement("svg", {
  "aria-hidden": "true",
  focusable: "false",
  "data-prefix": "fas",
  "data-icon": "times",
  className: "reactive-btn-error-svg",
  role: "img",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 352 512"
}, e.createElement("path", {
  fill: "currentColor",
  d: "M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"
})),
    C = function C(o) {
  var a = o.color ? o.color : "primary",
      i = o.idleText ? o.idleText : "Click Me",
      c = o.loadingText && "" !== o.loadingText ? o.loadingText : "Loading",
      s = o.successText && "" !== o.successText ? o.successText : "Success",
      l = o.errorText && "" !== o.errorText ? o.errorText : "Error",
      u = o.type ? o.type : "button",
      b = "reactive-btn".concat(o.className ? " " + o.className : ""),
      p = !!o.outline,
      d = !!o.shadow,
      v = o.style ? o.style : {},
      f = !!o.rounded,
      y = o.size ? o.size : "normal",
      m = void 0 === o.animation || !1 !== o.animation,
      x = r(t(o.buttonState ? o.buttonState : "idle"), 2),
      g = x[0],
      h = x[1];
  n(function () {
    void 0 !== o.buttonState && (h(o.buttonState), "success" !== o.buttonState && "error" !== o.buttonState || setTimeout(function () {
      h("idle");
    }, o.messageDuration ? o.messageDuration : 2e3));
  }, [o.buttonState, o.messageDuration]);
  var w;
  return e.createElement(e.Fragment, null, e.createElement("span", {
    className: "reactive-btn-wrapper ".concat(y).concat(o.block ? " block" : ""),
    style: {
      width: o.width,
      height: o.height
    }
  }, e.createElement("button", {
    ref: void 0 !== o.buttonRef ? o.buttonRef : null,
    disabled: "idle" !== g || o.disabled,
    "data-button-state": g,
    type: u,
    className: "".concat(b, " ").concat(a).concat(p ? " outline" : "").concat(m ? "" : " no-animation").concat(f ? " rounded" : "").concat(d ? " shadow" : "").concat(o.disabled ? " disabled" : ""),
    onClick: function onClick() {
      void 0 !== o.onClick && o.onClick();
    },
    style: v
  }, e.createElement("span", {
    className: "progress"
  }), e.createElement("span", {
    className: "content"
  }, e.createElement(e.Fragment, null, "idle" === (w = g) ? i : "loading" === w ? "Loading" === c ? e.createElement(e.Fragment, null, $, " ", c) : c : "success" === w ? "Success" === s ? e.createElement(e.Fragment, null, j, " ", s) : s : "error" === w ? "Error" === l ? e.createElement(e.Fragment, null, N, " ", l) : l : void 0)))));
};

C.propTypes = {
  color: i.exports.string,
  idleText: i.exports.oneOfType([i.exports.string, i.exports.node]),
  loadingText: i.exports.oneOfType([i.exports.string, i.exports.node]),
  successText: i.exports.oneOfType([i.exports.string, i.exports.node]),
  errorText: i.exports.oneOfType([i.exports.string, i.exports.node]),
  type: i.exports.string,
  className: i.exports.string,
  outline: i.exports.bool,
  shadow: i.exports.bool,
  style: i.exports.oneOfType([i.exports.object, i.exports.array]),
  rounded: i.exports.bool,
  size: i.exports.string,
  animation: i.exports.bool,
  buttonState: i.exports.string,
  onClick: i.exports.func,
  messageDuration: i.exports.number,
  block: i.exports.bool,
  width: i.exports.string,
  height: i.exports.string,
  buttonRef: i.exports.oneOfType([i.exports.func, i.exports.shape({
    current: i.exports.any
  })]),
  disabled: i.exports.bool
};
export { C as default };